export const environment = {
    production: true,
    api: 'https://info.midpass.ru/api',
    smartCaptchaPublicKey: 'ysc1_jYOrPCF0EcibWdChNcg8SW5caNuQ9ltChiAxuvCle0b52236',
};
